export enum EntityStatus {
   NotFound = 'NOT_FOUND',
   NoAccess = 'NO_ACCESS',
   Operative = 'OPERATIVE'
}

export enum BoardTypeEnum {
   customBoard = 'CUSTOM_BOARD',
   stageBoard = 'STAGE_BOARD',
   allPipelineItemsBoard = 'ALL_PIPELINE_ITEMS_BOARD',
   scheduledPipelineItemBoard = 'SCHEDULED_PIPELINE_ITEM_BOARD'
}

export enum GOFCategory {
   CustomGOF = 'CUSTOM_GOF',
   SystemGOF = 'SYSTEM_GOF'
}

export enum EntityTypeEnum {
   Lead = 'LEAD',
   Task = 'TASK',
   Activity = 'ACTIVITY',
   PipelineEvent = 'PIPELINE_EVENT',
   CustomObject = 'CUSTOM_OBJECT',
   Application = 'APPLICATION'
}

export enum BoardParentType {
   Pipeline = 'PIPELINE',
   Account = 'ACCOUNT',
   PipelineItemTemplate = 'PIPELINE_ITEM_TEMPLATE'
}

export enum PipelineEntityTypeEnum {
   Lead = 'LEAD',
   Task = 'TASK',
   Activity = 'ACTIVITY',
   Contact = 'CONTACT',
   Deal = 'DEAL',
   CustomObject = 'CUSTOM_OBJECT',
   Application = 'APPLICATION'
}

export const NO_LEAD_NAME = `NA`

export enum DealInitiatedEntity {
   Lead = 'LEAD',
   Contact = 'CONTACT'
}

export enum CRMItemTypeEnum {
   Lead = 'LEAD',
   Contact = 'CONTACT',
   Deal = 'DEAL',
   CustomObject = 'CUSTOM_OBJECT',
   Application = 'APPLICATION'
}
